// extracted by mini-css-extract-plugin
export default {"sign":"CautionSign-module__sign__0Yxj2","icon":"CautionSign-module__icon__4oi03"};